'use strict';

import Component from 'generic.basecomponent';
import TweenLite from 'gsap/TweenLite';
import $ from 'jquery';
import menuManager from 'menu-manager';

export default class MainNav extends Component {

    constructor(el) {
        super(el);
        this.defineVariables();
        this.initNav();
    }

    defineVariables() {
        this.menuId = 'mainSubNav';

        this.itemsSelector = ".js-main-nav-item";
        this.subsSelector = ".js-main-nav-sub";

        this.body = document.body;
        this.menuItems = [...document.querySelectorAll(this.itemsSelector)];

        this.bg = document.querySelector(".js-main-nav__bg");
        this.shadowBg = document.querySelector(".js-main-nav__shadow-bg");
        this.angleBg = document.querySelector(".js-main-nav__angle-bg");
        this.secondaryNav = this.container.querySelectorAll(this.subsSelector);

        this.isOpened = false;
        this.isItemHoveredMenuClass = 'is-item-hovered';
        this.isItemOpenedMenuClass = 'is-item-opened';
        this.isMenuItemHovered = false;
        this.selectedMenuItem = null;
        this.isItemOpenedClass = 'is-opened';
    }

    initNav() {
        this.menuItems.forEach(item => {
            item.addEventListener('mouseenter', this.onMouseOverItem.bind(this));
            let subNav = item.querySelector(this.subsSelector);
            if (subNav) {
                let link = item.querySelector('a');
                if (link) {
                    link.addEventListener('click', (e) => {
                        this.itemOpenOnClick(e, item, subNav);
                    });
                    link.addEventListener('mouseenter', (e) => {
                        this.itemOpenOnHover(e, item, subNav);
                    });
                }
            }
        });
        document.addEventListener('click', this.checkOuterClick.bind(this));
        this.container.addEventListener('mouseleave', this.onMouseLeave.bind(this));

        menuManager.init(this.menuId, {
            default: {
                open: this.openMenu.bind(this),
                close: this.closeMenu.bind(this),
                level: 0
            },
            mobile: {
                isEnabled: false
            }
        });
    }

    itemOpenOnHover(e, hoveredItem, subNav) {
        e.preventDefault();
        if (this.isOpened && hoveredItem !== this.selectedMenuItem) {
            this.handleItemOpen(hoveredItem, subNav);
        }
    }

    itemOpenOnClick(e, clickedItem, subNav) {
        e.preventDefault();
        if (this.selectedMenuItem !== clickedItem) {
            if (!this.isOpened) {
                menuManager.open(this.menuId);
            }
            this.handleItemOpen(clickedItem, subNav);
        }
    }

    handleItemOpen(clickedItem, subNav) {
        clickedItem.classList.add(this.isItemOpenedClass);
        this.selectedMenuItem = clickedItem;
        this.menuItems.forEach(item => {
            if (clickedItem !== item) {
                item.classList.remove(this.isItemOpenedClass);
            }
        });
        TweenLite.to(this.secondaryNav, 0.2, {autoAlpha: 0, display: 'none'});
        TweenLite.to(subNav, 0.2, {autoAlpha: 1, display: 'flex'});
    }

    checkOuterClick(e) {
        if (this.isOpened) {
            let $target = $(e.target);
            let itemsLinkSelector = `${this.itemsSelector} a`;
            let subnavLinkSelector = `${this.subsSelector} li a`;
            let subnavLiSelector = `${this.subsSelector} li`;
            if (!$target.is(itemsLinkSelector) && !($target.is(subnavLinkSelector) || $target.parents(subnavLiSelector).length)) {
                menuManager.close(this.menuId);
            }
        }
    }

    openMenu() {
        this.isOpened = true;
        this.container.classList.add(this.isItemOpenedMenuClass);
        TweenLite.to(this.bg, 0.3, {autoAlpha: 1, display: 'block'});
        TweenLite.fromTo(this.angleBg, 0.3, {y: 0}, {y: 800});
    }

    closeMenu() {
        this.isOpened = false;
        TweenLite.to(this.bg, 0.3, {delay: 0.2, autoAlpha: 0, display: 'none'});
        TweenLite.fromTo(this.angleBg, 0.3, {y: 800}, {y: 0});
        TweenLite.to(this.secondaryNav, 0.2, {autoAlpha: 0, display: 'none'});
        this.container.classList.remove(this.isItemOpenedMenuClass);
        this.selectedMenuItem.classList.remove(this.isItemOpenedClass);
        this.selectedMenuItem = null;
    }

    onMouseOverItem(e) {
        if (!this.isMenuItemHovered) {
            this.isMenuItemHovered = true;
            this.container.classList.add(this.isItemHoveredMenuClass);
        }
    }

    onMouseLeave(e) {
        this.container.classList.remove(this.isItemHoveredMenuClass);
        this.isMenuItemHovered = false;
    }
}

MainNav.id = 0;



// WEBPACK FOOTER //
// ./app/components/nav-main/js/generic.navmain.js